import { fetchWithRetry, responseError } from './apiError';
import { publishSkillStoreVisibility, SkillStoreVisibility } from './skillStoreVisibilityService';
import { tokenService } from './tokenService';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

/** System-admin write for the Skill Store visibility flag read by every surface. */
const setSkillStoreVisibility = async (enabled: boolean): Promise<SkillStoreVisibility> => {
  const response = await fetchWithRetry(`${API_URL}/api/v1/admin/settings/skill-store-visibility`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${tokenService.getAccessToken()}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ enabled }),
  });

  if (!response.ok) throw await responseError(response);

  const data = await response.json();

  publishSkillStoreVisibility(data?.enabled !== false);

  return { enabled: data?.enabled !== false };
};

export const skillStoreVisibilityAdminService = { setSkillStoreVisibility };
